//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        onChange (e) {
            this.$emit('change', e.currentTarget.dataset.key)
        }
    },
    computed: {
            scroll_into_view () {
                let view_id
                const len = this.tabs.length
                for (let i = 0; i < len; i++) {
                    const tab =  this.tabs[i]
                    if (tab.key === this.selected) {
                        if (i > 0 && i < len - 1) {
                            view_id = `tab-${i - 1}`
                        } else {
                            view_id = `tab-${i}`
                        }
                        break
                    }
                }
                console.error(view_id)
                return view_id
            }
        },
    props: {
        scroll: {
            type: Boolean,
            default: false
        },
        width: {
            type: String
        },
        tabs: {
            type: Array,
            validator (value) {
                if (value.length) {
                    return value.every(({ key, name }) => {
                        return key != undefined && name != undefined
                    })
                }
                return true
            }
        },
        selected: {
            type: [ String, Number ]
        }
    }
}
